<template>
  <div>
    <b-form @submit.prevent="save">
      <SettingsTitleBar sub="Team" :saving="saving"/>
        <b-alert show :variant="notification.type">{{notification.message}}</b-alert>
        <b-form-group label="Team Name:" label-for="team_name">
          <b-form-input v-model="form.name" id="team_name" placeholder="Enter team name"/>
        </b-form-group>
        <b-form-group label="Domain:" label-for="domain">
          <b-form-input v-model="form.domain" id="domain" placeholder="Enter domain"/>
        </b-form-group>
        <b-form-group label="Company Size:" label-for="company_size">
          <b-form-select v-model="form.company_size">
            <option value="">(select one)</option>
            <option>1 or 2</option>
            <option>3+</option>
            <option>10+</option>
            <option>30+</option>
            <option>100+</option>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Have Design?">
          <b-form-radio-group v-model="form.have_design" :options="[{text:'Yes', value:'yes'}, {text:'No', value: 'no'}]"/>
        </b-form-group>
      </b-form>

      <Restrictions v-model="restrictions"/>
    </div>


  </template>
<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  data() {
    return {
      form: {name: '', domain: ''},
      restrictions: {},
      saving: false,
      notification: {type: null, message:''},
    }
  },
  mounted() {
    this.form.name = this.team.name;
    this.form.domain = this.team.domain;
    this.form.company_size = this.team.company_size;
    this.form.have_design = this.team.have_design;
    this.restrictions = this.team.default_orderer_settings;
  },
  computed: mapGetters(['team']),
  methods: {
    ...mapActions(['updateTeam']),
    async save() {
      let message = this.formValidationError();
      if (message) {
        this.notification = {message, type: 'danger'};
        return;
      }
      this.saving = true;
      await this.updateTeam({...this.form, default_orderer_settings: this.restrictions});
      this.saving = false;
      this.$router.push('/dashboard/settings');
    },
    formValidationError() {
      if (!this.form.domain) return 'Please enter a domain';
      if (!this.form.name) return 'Please enter a team name';
      const DOMAIN_NAME = /[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+/;
      if (!DOMAIN_NAME.test(this.form.domain)) return 'Please enter a valid domain';
    },
  },
  watch: {
    restrictions: {
      deep: true,
      async handler(val, old) {
        // Ensure we don't trigger false alarms on load
        if (JSON.stringify(val) === JSON.stringify(this.team.default_orderer_settings)) {
          return;
        }
        this.saving = true;
        await this.updateTeam({default_orderer_settings: this.restrictions});
        this.saving = false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/EditTeam.vue